// src/components/common/PluginIconPlaceholder.tsx

interface PlaceholderProps {
    pluginName: string;
    className?: string;
    hideName?: boolean;
}

// Função para gerar as iniciais a partir do nome
const getInitials = (name: string) => {
    const words = name.split(/[\s-]+/).filter(Boolean);
    if (words.length === 0) return '?';
    if (words.length === 1) return words[0].substring(0, 1).toUpperCase();
    return (words[0].substring(0, 1) + words[words.length - 1].substring(0, 1)).toUpperCase();
};

export function PluginIconPlaceholder({ pluginName, className, hideName }: PlaceholderProps) {
    const initials = getInitials(pluginName);
    // Unique ID to avoid SVG def conflicts when multiple cards are on the same page
    const uid = pluginName.replace(/[^a-zA-Z0-9]/g, '').substring(0, 10);

    const centerY = hideName ? 100 : 90;
    const textY = hideName ? 105 : 95;

    return (
        <svg
            className={className}
            viewBox="0 0 300 200"
            preserveAspectRatio="xMidYMid slice"
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: '100%', height: '100%', display: 'block' }}
        >
            <defs>
                <linearGradient id={`bgGrad-${uid}`} x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#0D63F3" />
                    <stop offset="100%" stopColor="#0B52CC" />
                </linearGradient>
                <pattern id={`grid-${uid}`} width="30" height="30" patternUnits="userSpaceOnUse">
                    <path d="M 30 0 L 0 0 0 30" fill="none" stroke="rgba(255, 255, 255, 0.05)" strokeWidth="1" />
                </pattern>
            </defs>

            {/* Background */}
            <rect width="300" height="200" fill={`url(#bgGrad-${uid})`} />
            <rect width="300" height="200" fill={`url(#grid-${uid})`} />

            {/* Decorative circles */}
            <circle cx="150" cy={centerY} r="50" fill="none" stroke="rgba(255, 255, 255, 0.1)" strokeWidth="2" />
            <circle cx="150" cy={centerY} r="35" fill="rgba(255, 255, 255, 0.05)" />

            {/* Initials in the center */}
            <text
                x="150"
                y={textY}
                dominantBaseline="middle"
                textAnchor="middle"
                fill="#ffffff"
                fontSize={hideName ? "56" : "42"}
                fontWeight="800"
                fontFamily="'Poppins', sans-serif"
                letterSpacing="-1"
            >
                {initials}
            </text>

            {/* Plugin Name at the bottom */}
            {!hideName && (
                <text
                    x="150"
                    y="165"
                    dominantBaseline="middle"
                    textAnchor="middle"
                    fill="#ffffff"
                    fontSize="16"
                    fontWeight="700"
                    fontFamily="'Poppins', sans-serif"
                    opacity="0.9"
                >
                    {pluginName.length > 22 ? pluginName.substring(0, 22).toUpperCase() + '…' : pluginName.toUpperCase()}
                </text>
            )}
        </svg>
    );
}